export enum ViewportType {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
}

export type ViewportChangePayload = {
  type: ViewportType;
};
